import NotificationsContainer from './Notification.component';

export default NotificationsContainer;
